import HTTP from '../HTTP_GESCOM';
import transformer from '@/services/client/mandatTableDataTransformer';
const URL_BASE = 'commun/Mandat/';

export async function updateAll(payload) {
  const response = await HTTP.put(URL_BASE + 'UpdateAllAsync', payload);
  return response;
}

export async function createAll(mandat) {
  const response = await HTTP.post(URL_BASE + 'CreateAllAsync', mandat);
  return response;
}

export async function getAllAsync(idTiers) {
  const transformedQuery = transformer(idTiers);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', transformedQuery);
  return response;
}